import { useState } from 'react';

import { Tab } from './Tabs.v3.types';

interface UseTabsOptions {
	tabs: Tab[];
}

interface UseTabs {
	tabs: Tab[];
	selectedTabId: string;
	onSelectedTabIdChange: (id: string) => void;
}

export const useTabs = (options: UseTabsOptions): UseTabs => {
	const [selectedTabId, onSelectedTabIdChange] = useState(options.tabs.at(0)?.id ?? '');

	return {
		tabs: options.tabs,
		selectedTabId,
		onSelectedTabIdChange,
	};
};
